import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
	openedModals: [],
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};
